import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor() {
  }

  getUsers() {
    return null;
  }

  getCurrentUser(userId): Observable<any> {
    return null;
  }

  createUser(user) {
    return null;
  }

}
